import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AccountService } from 'src/app/services/account.service';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import {Location} from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-update-info',
  templateUrl: './update-info.component.html',
  styleUrls: ['./update-info.component.css']
})
export class UpdateInfoComponent implements OnInit {
  public contactForm: UntypedFormGroup;
  api_error: any;
  api_success: string;
  acc_id: string;
  statusTo: string;
  disableConfirmbtn = false;
  ContactInfoDeatils: any;
  btndisabled = false;
  constructor(private dialogRef: MatDialogRef<any>,private _location: Location,private routerobj: Router,
    private location: Location,
    private activaterouterobj: ActivatedRoute,private formbuilder: UntypedFormBuilder, private matDialog: MatDialogRef<any>, @Inject(MAT_DIALOG_DATA) public data: any, private accountService: AccountService,) {
    this.contactForm = this.formbuilder.group({

      contactFirstName: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(10), Validators.pattern('^[0-9]*$')]],
      contactLastName: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(10), Validators.pattern('^[0-9]*$')]],
      primaryPhoneNumber: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(10), Validators.pattern('^[0-9]*$')]],
      primaryEmail: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(10), Validators.pattern('^[0-9]*$')]],
      secondaryPhoneNumber: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(10), Validators.pattern('^[0-9]*$')]],
      whatsappPhoneNumber: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(10), Validators.pattern('^[0-9]*$')]],
      secondaryEmail: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(10), Validators.pattern('^[0-9]*$')]],
      address: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(10), Validators.pattern('^[0-9]*$')]],
     

    });
   }
  formErrors = {
    'contactFirstName': '',
    'contactLastName': '',
    'primaryPhoneNumber': '',
    'primaryEmail': '',
    'secondaryPhoneNumber': '',
    'whatsappPhoneNumber': '',
    'secondaryEmail': '',
    'address': '',

  };
  ValidationMessages = {
    'contactFirstName': {
      'required': 'First Name is Required',
      'whitespace': 'First Name  is invalid'
    },
    'contactLastName': {
      'required': 'Last Name is Required'
    },
    'primaryPhoneNumber': {
      'minlength': 'Phone # should have a minimum length of 10 characters',
      'maxlength': ' Phone #  should only have a maximum length of 10 characters',
    },
    'whatsappPhoneNumber': {
      'minlength': 'Phone # should have a minimum length of 10 characters',
      'maxlength': ' Phone #  should only have a maximum length of 10 characters',
    },
    'primaryEmail': {
      'email': 'email is invalid'

    },
    'address': {
      'email': 'email is invalid'

    },
    'secondaryPhoneNumber' : {
      'minlength': 'Phone # should have a minimum length of 10 characters',
      'maxlength': ' Phone #  should only have a maximum length of 10 characters',
    },
    'secondaryEmail': {
      'email': 'email is invalid'

    },
  };
  ngOnInit() {
   
    this.ContactInfoDeatils = this.data
    // console.log(this.ContactInfoDeatils.account);
    this.updateContactForm(this.ContactInfoDeatils);
  }
  logValidationErrors(group: UntypedFormGroup = this.contactForm): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      this.formErrors[key] = '';
      if (abstractControl && !abstractControl.valid &&
        (abstractControl.touched || abstractControl.dirty)) {
        const messages = this.ValidationMessages[key];
        for (const errorKey in abstractControl.errors) {
          if (errorKey) {
            this.formErrors[key] += messages[errorKey] + ' ';
          }
        }
      }

      if (abstractControl instanceof UntypedFormGroup) {
        this.logValidationErrors(abstractControl);
      }
    });
  }
  public closeDialog() {
    this.dialogRef.close();
  }
  updateContactForm(ContactInfoDeatils) {
    // console.log(ContactInfoDeatils);
    this.contactForm.patchValue({
     
      contactLastName: ContactInfoDeatils.contactLastName,
      contactFirstName: ContactInfoDeatils.contactFirstName,
      primaryPhoneNumber : ContactInfoDeatils.primaryPhoneNumber,
      whatsappPhoneNumber: ContactInfoDeatils.whatsappPhoneNumber,
      primaryEmail: ContactInfoDeatils.primaryEmail,
      secondaryPhoneNumber: ContactInfoDeatils.secondaryPhoneNumber,
      secondaryEmail: ContactInfoDeatils.secondaryEmail,
      address: ContactInfoDeatils.address,
      countryCode: '+91',
      secondaryCountryCode: '+91',
      whatsappCountryCode: '+91',
    });

  }
  ContactInfo(accountId){
   this.accountService.getContactInfo(accountId)
       .subscribe(res => {
        this.ContactInfoDeatils = res;
        // console.log(this.ContactInfoDeatils)
       });
  }
  onContactSubmit() {
    this.btndisabled = true;
    const form_data = this.contactForm.value;
  //  console.log('formdata to submit........' + form_data);
     this.updateContactData(form_data);
   
  }
  updateContactData(data) {
    this.accountService.updateScontact(data , this.ContactInfoDeatils.account)
    .subscribe(res => {
      this.btndisabled = false;
     this.api_success = 'Contact Information Updated Successfully';
     setTimeout(() => {
       this.matDialog.close();
     }, 2000);
     
   },

     (error) => {
      this.btndisabled = false;
       this.api_error = error.error;
     }
   );
  
   this.ContactInfo(this.ContactInfoDeatils.account);
  }
}